module.exports = __webpack_public_path__ + "media/images/arrow-next-e922a37b185da262c0d989883e60cfce.svg";